const utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'propose-unapproved-list',
  created () {
    this.search(false)
    this.proposeCount()
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      searchCallbackFlag: false
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    proposes () {
      return this.$store.getters.proposeUnapprovedList
    },
    proposeTotalCount () {
      return this.$store.getters.proposeUnapprovedTotalCount
    },
    nextPage () {
      return this.$store.getters.proposeUnapprovedListNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function (readMore) {
      let url = null
      if (readMore) {
        url = this.$store.getters.proposeUnapprovedListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      const self = this
      const callback = function () {
        self.searchCallbackFlag = true
      }
      const data = {'propose_status': 'unapproved'}
      this.$store.dispatch('PROPOSE_UNAPPROVED_LIST_SEARCH', {url: url, data: data, callback: callback})
    },
    proposeCount: function () {
      const data = {'status': 'unapproved'}
      this.$store.dispatch('PROPOSE_COUNT', {data: data})
    },
    goProposeDetail: function (proposeId) {
      this.$router.push({ path: '/propose_unapproved/' + proposeId })
    },
    proposeDelete: function (proposeId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('PROPOSE_DELETE', {id: proposeId, callback: this.onSaved})
      }
    },
    onSaved: function () {
      this.$router.push('/propose_unapproved_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose-unapproved-list.js